<template>
  <div class="wp" v-html="datas"></div>
</template>

<script>
export default {
    name: "HtmlComponent",
    props: {
        data: ""
    },
    data: function (){
        return {
            datas: null
        }
    },
    watch: {
        data: {
            handler(newName) {
                // console.log(newName,"newName")
                this.datas = newName;
            },
            deep: true
        }
    }
}
</script>

<style>
.wp {
    width: 100%;
    overflow: hidden;
}
.wp div{
    width: 100% !important;
}
.wp img {
    width:7.5rem!important;
    /* /* height:100%; */
    display:block!important;
    padding: 0 !important;
}
</style>